import React from "react";
import circule from "./../../../assets/icons/circule.png";

function TableRadioIcon() {
  return <img src={circule} />;
}

export default TableRadioIcon;
